export default __webpack_public_path__ + "static/media/buddy carter.9126a499.jpg";